import { render, staticRenderFns } from "./ChatConversation.vue?vue&type=template&id=58182108&scoped=true"
import script from "./ChatConversation.vue?vue&type=script&lang=js"
export * from "./ChatConversation.vue?vue&type=script&lang=js"
import style0 from "./ChatConversation.vue?vue&type=style&index=0&id=58182108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58182108",
  null
  
)

export default component.exports